import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AccountWishlistComponentDef } from '@df/account/account-wishlist.component.def';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ProductComponent } from '../../catalog/ui/product/product.component';
import { WishlistSortPipe } from '../../catalog/ui/wishlist/wishlist-sort.pipe';

@Component({
    selector: 'account-wishlist',
    templateUrl: './account-wishlist.component.html',
    standalone: true,
    imports: [ProductComponent, TranslatePipe, WishlistSortPipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountWishlistComponent extends AccountWishlistComponentDef {}
